import { render, staticRenderFns } from "./MyContent.vue?vue&type=template&id=522fb0f5"
import script from "./MyContent.vue?vue&type=script&lang=js"
export * from "./MyContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports